<template>
  <v-container grid-list-xl>
    PROMOTE CONTAINER
  </v-container>
</template>

<script>



export default {
  name: 'promote-container',
  data(){
    return {
    }
  },
}
</script>

<style>

</style>
